import '@vitejs/plugin-react/preamble';
import TimeseriesConfig from './TimeseriesConfig';

export default { TimeseriesConfig };
